import { useQuery } from "@tanstack/react-query";

import { getKBTypes, type KBEquipmentSummary } from "@/lib/api/agent";
import {
  findEquipmentTypeOption,
  groupedEquipmentTypeOptions,
} from "@/lib/kb-catalog-nav";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export function EquipmentTypeSelect({
  eqMeta,
  value,
  onChange,
}: {
  eqMeta: Record<string, KBEquipmentSummary>;
  value: string;
  onChange: (type: string) => void;
}) {
  const { data: kbTypes } = useQuery({
    queryKey: ["kb-types"],
    queryFn: getKBTypes,
    staleTime: Infinity,
  });

  const sensors = kbTypes?.sensor_types ?? [];
  const groups = groupedEquipmentTypeOptions(eqMeta, sensors);
  const current = findEquipmentTypeOption(groups, value);
  const currentMissing = Boolean(value) && !current;

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-9 w-full text-sm">
        <SelectValue placeholder="Valitse tyyppi…">
          {current?.name_fi ?? value}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="max-h-72">
        {currentMissing && <SelectItem value={value}>{value}</SelectItem>}
        {groups.map((group) => (
          <SelectGroup key={group.group_fi}>
            <SelectLabel className="text-[10px] uppercase tracking-[0.13em] text-muted-foreground">
              {group.group_fi}
            </SelectLabel>
            {group.options.map((opt) => (
              <SelectItem key={opt.type} value={opt.type}>
                {opt.icon} {opt.name_fi}
              </SelectItem>
            ))}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
}
